export default {
    url: '/add',
    template: '<manage-permissions-companies-add company="vm.company" countries="vm.countries"/>',
    resolve: {
        countries (CountryResource) {
            return CountryResource.query().$promise;
        }
    },
    controller (CompanyResource, countries) {
        this.company = new CompanyResource();
        this.countries = countries;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/companies/add/index.js